import { actionCreatorFactory } from 'typescript-fsa';
import { IApiErrorParams, IApiCreateServerRes } from '@cbridge-packages/api';
import { IResolverMeta } from '@cbridge-utils/redux-observable';
import { IStream } from '@cbridge-packages/stream';
import { IServer, IServerBase, IServerListKey, IServerDetails, IServerStreamForm } from './server.interface';

export namespace ServerAction {
  const actionCreator = actionCreatorFactory('Server');

  export const load = actionCreator.async<{ serverId: IServer['serverId'] }, IServerDetails, IApiErrorParams>('LOAD');

  export const loadList = actionCreator.async<IServerListKey, IServer[], IApiErrorParams>('LOAD_LIST');

  export const processing = actionCreator.async<void, void, { error: Error }>('PROCESSING');

  interface IServerCreateParams extends IServerBase, Pick<IResolverMeta, 'reject'> {
    resolve?: (result: IApiCreateServerRes) => void;
  }

  export const create = actionCreator.async<IServerCreateParams, IApiCreateServerRes, void>('CREATE');

  interface IServerUpdateParams {
    serverId: IServer['serverId'];
    throttlingInterval?: IServer['throttlingInterval'];
    riskReportingEnabled?: IServer['riskReportingEnabled'];
  }

  export const update = actionCreator.async<IServerUpdateParams, void, void>('UPDATE');
  export const remove = actionCreator.async<{ serverId: IServer['serverId'] }, void, void>('REMOVE');

  interface IGenerateSecretParams extends Pick<IResolverMeta, 'reject'> {
    serverId: IServer['serverId'];
    resolve?: (secret: string) => void;
  }

  export const generateSecret = actionCreator.async<IGenerateSecretParams, { secret: string }, IApiErrorParams>('GENERATE_SECRET');

  interface IServerStreamCreateParams extends IResolverMeta {
    payload: IServerStreamForm;
  }

  interface IServerStreamUpdateParams extends IResolverMeta {
    payload: IServerStreamForm;
  }

  export const createServerStream = actionCreator.async<IServerStreamCreateParams, void, IApiErrorParams>('CREATE_SERVER_STREAM');
  export const updateServerStream = actionCreator.async<IServerStreamUpdateParams, void, IApiErrorParams>('UPDATE_SERVER_STREAM');
  export const removeServerStream = actionCreator.async<{ serverId: IServer['serverId']; streamId: IStream['streamId'] }, void, void>('REMOVE_SERVER_STREAM');

  export const destroy = actionCreator('DESTROY');
}
